<div class="flex flex-col gap-4 border-solid border-b border-x-0 border-t-0 border-shui-base-4 pb-8">
    <span class="text-base font-semibold text-shui-text-strong">{{
        'request.requestDetail.contact-information' | translate
    }}</span>
    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px]">
        <sh-input-text
            [label]="'request.overview.customer' | translate"
            [value]="customerEmail() ?? ''"
            type="email"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'request.overview.tas' | translate"
            [value]="tasEmail() ?? ''"
            type="email"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'request.overview.sales-rep' | translate"
            [value]="salesRepEmail() ?? ''"
            type="email"
            disabled
        ></sh-input-text>
        <sh-input-text
            [label]="'request.overview.project-manager' | translate"
            [value]="pmInstallationEmail() ?? ''"
            type="email"
            disabled
        ></sh-input-text>
    </div>
    @if (additionalContacts().length) {
        <span class="text-sm font-semibold text-shui-text-strong mt-2">{{
            'request.overview.additional-contacts' | translate
        }}</span>
        @for (contact of additionalContacts(); track $index) {
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-[900px]">
                <sh-input-text
                    [label]="'request.contact-information.additional-contact-name' | translate"
                    [value]="contact.title"
                    disabled
                ></sh-input-text>
                <sh-input-text
                    [label]="'request.contact-information.additional-contact-email' | translate"
                    [value]="contact.email"
                    type="email"
                    disabled
                ></sh-input-text>
            </div>
        }
    }
</div>
